var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('span',{attrs:{"endTime":_vm.endTime,"endText":_vm.endText}},[_vm._v("\n  "+_vm._s(_vm.countDownList)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }